<template>
    <button
        v-if="eventAdvancedSearch"
        class="btn unfocus container-advanced-search"
        @click.prevent="onSearchAdvanced">
        <span class="button-wrapper">
            <div class="wrapper-icon-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 5.5C15.25 4.80964 15.8096 4.25 16.5 4.25C17.1904 4.25 17.75 4.80964 17.75 5.5C17.75 6.19036 17.1904 6.75 16.5 6.75C15.8096 6.75 15.25 6.19036 15.25 5.5ZM13.8535 6.25C14.18 7.40425 15.2412 8.25 16.5 8.25C18.0188 8.25 19.25 7.01878 19.25 5.5C19.25 3.98122 18.0188 2.75 16.5 2.75C15.2412 2.75 14.18 3.59575 13.8535 4.75H2.5C2.08579 4.75 1.75 5.08579 1.75 5.5C1.75 5.91421 2.08579 6.25 2.5 6.25H13.8535ZM1.75 12C1.75 11.5858 2.08579 11.25 2.5 11.25H4.85352C5.17998 10.0957 6.24122 9.25 7.5 9.25C9.01878 9.25 10.25 10.4812 10.25 12C10.25 13.5188 9.01878 14.75 7.5 14.75C6.24122 14.75 5.17998 13.9043 4.85352 12.75H2.5C2.08579 12.75 1.75 12.4142 1.75 12ZM7.5 13.25C6.80964 13.25 6.25 12.6904 6.25 12C6.25 11.3096 6.80964 10.75 7.5 10.75C8.19036 10.75 8.75 11.3096 8.75 12C8.75 12.6904 8.19036 13.25 7.5 13.25ZM10.75 12C10.75 11.5858 11.0858 11.25 11.5 11.25H21.5C21.9142 11.25 22.25 11.5858 22.25 12C22.25 12.4142 21.9142 12.75 21.5 12.75H11.5C11.0858 12.75 10.75 12.4142 10.75 12ZM17.5 17.75C17.0858 17.75 16.75 18.0858 16.75 18.5C16.75 18.9142 17.0858 19.25 17.5 19.25H21.5C21.9142 19.25 22.25 18.9142 22.25 18.5C22.25 18.0858 21.9142 17.75 21.5 17.75H17.5ZM1.75 18.5C1.75 18.0858 2.08579 17.75 2.5 17.75H10.8535C11.18 16.5957 12.2412 15.75 13.5 15.75C15.0188 15.75 16.25 16.9812 16.25 18.5C16.25 20.0188 15.0188 21.25 13.5 21.25C12.2412 21.25 11.18 20.4043 10.8535 19.25H2.5C2.08579 19.25 1.75 18.9142 1.75 18.5ZM12.25 18.5C12.25 19.1904 12.8096 19.75 13.5 19.75C14.1904 19.75 14.75 19.1904 14.75 18.5C14.75 17.8096 14.1904 17.25 13.5 17.25C12.8096 17.25 12.25 17.8096 12.25 18.5ZM19.75 5.5C19.75 5.08579 20.0858 4.75 20.5 4.75H21.5C21.9142 4.75 22.25 5.08579 22.25 5.5C22.25 5.91421 21.9142 6.25 21.5 6.25H20.5C20.0858 6.25 19.75 5.91421 19.75 5.5Z" fill="currentColor"/>
                </svg>
                <span class="text-advanced">{{ $t(`navsearch.advanced.label`) }}</span>
            </div>
        </span>
    </button>
</template>
<script>
export default {
    props: {
        moduleCode: {
            type: String,
            require: true
        },
        eventAdvancedSearch: {
            type: String,
            default: null
        },
    },
    data() {
        return {
        }
    },
    methods: {
        onSearchAdvanced() {
            if(this.eventAdvancedSearch) {
                this.$eventBus.publish(this.moduleCode, this.eventAdvancedSearch, {show: true});
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.container-advanced-search {
    padding: 0;
    min-width: auto;
    margin: 0 0 0 20px;

    .wrapper-icon-text {
        display: flex;
        gap: 9.75px;
        color: var(--primary-color);

        .text-advanced {
            font-family: var(--city-font-family);
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            display: flex;
            align-items: center;
            text-align: center;
            text-transform: uppercase;
            flex: none;
            order: 1;
            flex-grow: 0;
        }
    }
}
</style>